.head {
  max-width: 860px;
  margin-bottom: 44px;
}

.head__title {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  /* HACK: fluid display size — candidate future DS heading scale */
  font-size: clamp(32px, 4vw, 52px);
  line-height: 1.04;
  letter-spacing: -0.02em;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 14px;
}

.head__lede {
  font-size: 18px;
  line-height: 1.5;
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 (text-2) */
  margin: 0;
}

/* Larger variant (Press): a bigger display title and an ink-colored HEADING_XS lede. */
.headLg .head__title {
  font-size: clamp(36px, 4.8vw, 64px);
  line-height: 1;
  margin-bottom: 16px;
}

.headLg .head__lede {
  font-size: 19px; /* HEADING_XS */
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

/*
 * Wider variant: no measure on the head itself; the title runs to 1060px — one line where the
 * default 860px wraps it — while the lede keeps its own 68ch measure. Kicker and lede both sit one
 * step up the scale, at HEADING_XS.
 */
.headWide {
  max-width: none;
  margin-bottom: 48px;
}

.headWide .head__title {
  /* HACK: fluid display size — candidate future DS heading scale */
  font-size: clamp(32px, 4.2vw, 52px);
  line-height: 1.02;
  max-width: 1060px;
  margin-bottom: 16px;
}

.headWide .head__kicker {
  font-size: 19px; /* HEADING_XS */
}

.headWide .head__lede {
  font-size: 19px; /* HEADING_XS */
  line-height: 1.55;
  max-width: 68ch;
}

/* The run of the title set apart in red italic (e.g. "… au service de <em>votre succès !</em>"). */
.head__titleHighlight {
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
  font-style: italic;
}

.head__kicker {
  font-size: 11px; /* COPY_XS */
  /* HACK: the design's label weight is heavier than any COPY token, which tops out at 600. */
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--color-text-tertiary); /* TEXT_TERTIARY */
  margin: 0 0 16px;
}
